export const editDialogType = {
  create: "新建",
  edit: "编辑",
  copy: "新建"
}

export const subtaskTableColumns = [
  {
    label: "任务标题",
    prop: "name",
    required: true,
    width: 200
  },
  {
    label: "任务分组",
    prop: "groupId",
    required: false
  },
  {
    label: "负责人",
    prop: "assignee",
    required: false,
    width: 200
  },
  {
    label: "任务状态",
    prop: "status",
    required: false
  },
  {
    label: "开始时间",
    prop: "startAt",
    required: false,
    width: 215
  },
  {
    label: "截止时间",
    prop: "dueDate",
    required: false,
    width: 215
  },
  {
    label: "任务类型",
    prop: "typeId",
    required: true,
    width: 140
  },
  {
    label: "任务优先级",
    prop: "priority",
    required: false,
    width: 100
  },
  {
    label: "任务备注",
    prop: "description",
    required: false,
    width: 260
  }
]
